module.exports = __webpack_public_path__ + "static/scale-model-of-denver-zoo-in-denver-colorado-94c28731fa5bf5419748093ca5d5fea1.png";